<template>
  <div class="module-release-flow-add">
    <Card shadow class="content">
      <div>
        <Row class="title">
          <h4 :style="{float: 'left'}">申请模块的基本信息</h4>
        </Row>
        <GeneralAlert></GeneralAlert>
        <Form inline :label-width="68" :rules="baseInfoFormRules" ref="baseInfo" :model="baseInfo">
          <Row>
            <Col :md="24" :lg="12">
              <FormItem label="模块名" style="width: 100%" prop="name">
                <Input :maxlength="100" v-model="baseInfo.name" placeholder="请填写申请的模块名"/>
              </FormItem>
            </Col>
            <Col :md="24" :lg="12">
              <FormItem label="开发人员" style="width: 100%" prop="developers">
                <Select v-model="baseInfo.developers" multiple placeholder="选择开发人员" filterable transfer>
                  <Option v-for="item in userList" :key="item.id" :value="item.id">{{ item.name ? item.name : item.username }}</Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="24">
              <FormItem label="描述" style="width: 100%">
                <Input type="textarea" :maxlength="512" v-model="baseInfo.description" :rows="6" placeholder="模块描述" />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div style="text-align: center;">
        <Button type="primary" style="margin-right: 10px" :loading="submitting" @click="submit">提交申请</Button>
        <Button @click="$router.go(-1)">取消</Button>
      </div>
    </Card>
  </div>
</template>

<script>
import { GetALLUsers } from '@/api/user'
import { createModuleReleaseFlow } from '@/api/workflow/module_release_flow'
import GeneralAlert from '../components/general-alert'

export default {
  name: 'edit',
  components: {
    GeneralAlert
  },
  data () {
    return {
      submitting: false,
      baseInfo: {
        name: '',
        description: '',
        developers: []
      },
      baseInfoFormRules: {
        name: { required: true, message: '模块名不能为空', trigger: 'blur' }
      },
      userList: []
    }
  },
  created: function () {
    this.getAllUserData()
  },
  methods: {
    // 获取所有用户数据
    getAllUserData () {
      GetALLUsers().then(res => {
        this.userList = res.data
      })
    },
    // 提交
    submit () {
      this.$refs.baseInfo.validate((valid) => {
        if (valid) {
          this.submitting = true
          createModuleReleaseFlow(this.baseInfo).then(res => {
            this.$Notice.success({title: '操作成功'})
            this.$router.push({name: 'moduleReleaseFlowDetail', params: { id: res.data.id }})
            this.submitting = false
          }).catch(res => {
            this.submitting = false
            console.log(res.response)
            if (res.request) {
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '操作失败！'
              })
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  @import '../../base.less';
</style>
